import React, {createContext, useEffect, useRef, useState} from "react";
import Pusher from "pusher-js";
import caAPI from "../services/caAPI";

const pusher = new Pusher('ZWmsypUbT9C', {
  wsHost: 'wsdommus.dommus2.com.br',
  wssPort: 6001,
  forceTLS: true,
  enabledTransports: ['ws', 'wss'],
  authEndpoint: `${process.env.REACT_APP_CA_API}/broadcasting/auth`,
  auth: {
    headers: {
      Authorization: caAPI.getLocalState('token'),
    }
  }
})
export const WebSocketContext = createContext({});
export function WebSocketProvider ({children}) {
  const canalPresenca = useRef(null)
  const [channel, setChannel] = useState(pusher);
  const [usuariosOnline, setUsuariosOnline] = useState([])

  useEffect(() => {
    const idCliente = caAPI.getLocalState('idCliente') ?? '';
    let channel_name = 'inquilino-'+idCliente.toString().padStart(4, '0');
    if(process.env.REACT_APP_ENV === 'local') channel_name = 'local';
    setChannel(pusher.subscribe(channel_name));
    // canalPresenca.current = pusher.subscribe(`presence-${channel_name}`)
    if(canalPresenca.current) {
      canalPresenca.current.bind("pusher:subscription_succeeded", (dados) => {
        const usuarios = []
        Object.values(dados.members || {}).forEach(usuario => usuarios.push(usuario))
        console.log(usuarios)
        setUsuariosOnline(usuarios)
      });
    }
  }, [ setChannel])

  return (
    <WebSocketContext.Provider value={{ channel, canalPresenca: canalPresenca?.current }}>
      {children}
    </WebSocketContext.Provider>
  )
}
